import { compose } from 'ramda';
import { connect } from 'react-redux';

import { GalleryPlaceholder, IGalleryPlaceholderProps } from '../../components/GalleryPlaceholder';
import { getSlides } from '../../selectors/fotorama';
import { IState } from '../../store';
import { withEmptyRenderingOneOf } from '../../utils/hoc/withEmptyRendering/shared';

export interface IStoreProps extends IGalleryPlaceholderProps {
  isVisible: boolean;
}

export function mapStateToProps(state: IState): IStoreProps {
  const slides = getSlides(state);

  return {
    imageUrl: slides.length ? slides[0].img : undefined,
    isFat: state.isFatCard,
    isVisible: !!slides.length && !state.gallery.isInitialized,
    isMobile: state.device.deviceType !== 'desktop',
  };
}

export const GalleryPlaceholderContainer = compose(
  connect(mapStateToProps),
  withEmptyRenderingOneOf<IStoreProps>(['isVisible']),
)(GalleryPlaceholder);
